//----- loading animation
$(window).on('load',function(){
  $('.header, .nav-component').ready(function(){
    $('.loading-animation').delay(500).fadeOut(200);
  });
  //----- animated test paper
  if ($(window).width() >  1366 ){
    $('body').mousemove(function(e){
      var moveX = (e.pageX * -1 / 50);
      var moveY = (e.pageY * -1 / 50);
        $('.test-paper').css('background-position', moveX+'px '+moveY+'px');
    });
  };
});

//--
let navMenu = document.querySelector('#navMenu');
let allNavTitle = navMenu.querySelectorAll('.nav-title');
let allNavList = navMenu.querySelectorAll('.nav-list');
let hideEach = (dom, array, targetClass, activeCtrl, displayCtrl) => {
    if(dom){
        let nextArray = dom.parentNode.querySelectorAll(targetClass);
        nextArray.forEach((each)=>{
            if(activeCtrl){
                each.classList.remove('nav-active');
            }
            if(displayCtrl){
                each.classList.add('dn');
            }
        })
    }
    else{
        array.forEach((each)=>{
            if(activeCtrl){
                each.classList.remove('nav-active');
            }
            if(displayCtrl){
                each.classList.add('dn');
            }
        })
    }
}

allNavTitle.forEach((title)=>{
    title.addEventListener('click',(e)=>{
        e.preventDefault;
        if(title.nextElementSibling){
            if(title.nextElementSibling.classList.contains('nav-active')){
                
                hideEach('', allNavTitle, '.nav-title', true, false);
                hideEach(title, allNavList, '.nav-list', true, true);
                title.nextElementSibling.classList.remove('nav-active');
                title.nextElementSibling.classList.add('dn');
            }
            else{
                hideEach(title, allNavTitle, '.nav-title', true, false);
                hideEach(title, allNavList, '.nav-list', true, true);
                title.nextElementSibling.classList.add('nav-active');
                title.nextElementSibling.classList.remove('dn');
                e.target.classList.add('nav-active');
            }
        }
    })
})
hideEach('', allNavList, '.nav-title', true, true);



//----- location.hash
let hashId = location.hash
function locationHash() {
  let hashClass = hashId.split('#page-')[1]
  let hashClassSplit = hashClass.split('-2')[0]
  if (hashId === '#page-one' || hashId === '#page-two' || hashId === '#page-three' || hashId === '#page-four') {
    $(`#page-one`).removeClass('tab-default')
    $(`.tabs`).removeClass('tab-active')
    $(hashId).addClass('tab-default')
    $(`#navMenu .tabs.nav-tab-${hashClass}`).addClass('tab-active')
    $(`#tab-component .tabs.tab-${hashClass}`).addClass('tab-active')
  }
  else if(hashId === '#page-one-2' || hashId === '#page-three-2'){
    $(`#page-one`).removeClass('tab-default')
    $(`.tabs`).removeClass('tab-active')
    $(`#page-${hashClassSplit}`).addClass('tab-default')
    $(`#navMenu .tabs.nav-tab-${hashClassSplit}`).addClass('tab-active')
    $(`#tab-component .tabs.tab-${hashClassSplit}`).addClass('tab-active')
  }
  
  //----- scroll to position
  $(document).ready(function(){
    //----- hide
    $('.tab-pages:not(.tab-default)').hide();
    $('.tab-default').show();
    $('html, body').animate({
      scrollTop: $(hashId).offset().top-60
      }, 1000);
    
  });
};
//---- if ready, do locationHash()
$(document).ready(function(){
  if(hashId === '#page-one' || hashId === '#page-two' || hashId === '#page-three' || hashId === '#page-four' ||hashId === '#page-one-2' || hashId === '#page-three-2'){
    locationHash();
  }
  else{
  }  
});

//----- nav-component
$('#navToggle').on('click', function(){
  $('#navToggle,#navMenu').toggleClass('nav-active');
})
  //nav-component auto toggle when link clicked
$('.nav-link a').on('click', function(){
  $('#navToggle,#navMenu').removeClass('nav-active');
})
$('.nav-tabs .tabs').on('click', function(){
  $('#navToggle,#navMenu').removeClass('nav-active');
})
//----- tabs
$('.tabs').on('click', function() {
  var tabNumber = $(this).data('type');
  $(this).addClass('tab-active').siblings('.tabs').removeClass('tab-active');
  $('#page-' + tabNumber).fadeIn(300).show().siblings('.tab-pages').fadeOut(300).hide();
  $('.slider-nav, .slider-for').slick('setPosition');
})
$('.tab-pages:not(.tab-default)').hide()

//----- page1 - slick.js !!important: snyc need to set same speed! 
$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 600,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav',
  swipe: false
});
$('.slider-nav').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  speed: 600,
  asNavFor: '.slider-for',
  dots: false,
  arrows: true,
  focusOnSelect: true,
  nextArrow: $('.next-arrow'),
  prevArrow: $('.prev-arrow'),
  swipe: false
});

$('.slide-nav[data-slide]').click(function(e) {
  e.preventDefault();
  var slideNo = $(this).data('slide');
  $('.slider-nav').slick('slickGoTo', slideNo - 1);
  $(this).addClass('snav-active').siblings('.slide-nav').removeClass('snav-active');
});
$('.slider').on('afterChange', function (event, slick, currentSlide) {
  var number = currentSlide;
  $('.slide-navigation .slick-slide').removeClass('snav-active');
  $('.slide-navigation li').eq(number).addClass('snav-active').siblings('li').removeClass('snav-active');
});
//----- stop all iframe emmbed in sider-for
$(".iframe-thumbnail").on('click', function(){
  var VideoSrc = $(this).data('src');
  var VideoNum = $(this).data('type');
  $("#detaisVideo" + VideoNum + " iframe").attr('src',VideoSrc);
  $(".iframe-thumbnail").hide();

});
$(".slide-nav, .nav-pills a, .tabs, .sync-nav, .prev-arrow, .next-arrow").on('click', function() {
  $(".slider-for iframe").each(function(){
    $(this).attr("src","");
    $(".iframe-thumbnail").show();
  })
});
// $(".slide-nav, .nav-pills a, .tabs, .sync-nav, .prev-arrow, .next-arrow").on('click', function() {
//   $(".slider-for iframe").each(function(){
//     var videoSrcdoc = $(this).attr("srcdoc");
//     $(this).attr("srcdoc","");
//     $(this).attr("srcdoc",videoSrcdoc).fadeIn(300);
//   })
// });
//----- Modal dynamic video
$('.thumbnail-elements').on('click',function(){
  var modalVideoSrc = $(this).data('src');
  $('#dynamicVideo iframe').attr('src',modalVideoSrc).fadeIn(300);
})
    //clicked close, clear iframe content
$("#modalVideo, .close-modal").on("click",function(e){
  if($(e.target).closest("#modalVideo .modal-content").length){
    $("#dynamicVideo iframe").each(function(){
      $(this).attr("src","");
    })
  }else{
    $("#dynamicVideo iframe").each(function(){
      $(this).attr("src","");
    })
  }
});
//----- tab3 btn sync to tab1 nav
$('.sync-nav[data-slide]').click(function(e) {
  e.preventDefault();
  $('.nav-tab-one').click();
  var slideNo = $(this).data('slide');
  $('.slider-nav').slick('slickGoTo', slideNo - 1);
  $(this).addClass('snav-active').siblings('.slide-nav').removeClass('snav-active');
});

//----- auto update google sheet + -----  weekly schedule update google sheet
var qa,week; //載入兩個以上的表單
var publicSpreadsheetUrl1 = 'https://docs.google.com/spreadsheets/d/1TDucaOdczsGJAHUaCCyZJakAAXDoX2oQ9aynrxC6qRs/edit#gid=0';
var publicSpreadsheetUrl2 = 'https://docs.google.com/spreadsheets/d/1xKGOVpumngWcjL9OfZ_Dc8MrIMcsMOJ4Yz2lyYF0Gfg/edit#gid=0';

function init() {
  qa = Tabletop({
      key: publicSpreadsheetUrl1,
      callback: showInfoQa, //自定義命名,區分呼叫不同表單
      simpleSheet: true
  });
  week = Tabletop({
      key: publicSpreadsheetUrl2,
      callback: showInfoWeek,
      simpleSheet: false //有分頁需設置false
  });
}
  //QA部分
function showInfoQa(data, tabletop) {
  // console.log(data);
  var str = "";
  for (var i=0; i<data.length; i++) {
    str +='<tr><td>'+ data[i].subject +'</td><td>'+ data[i].id +'</td><td>'+ data[i].questionText +'<img src="'+ data[i].questionImg + '"></img></td><td>' + data[i].replyText +'<img src="'+ data[i].replyImg + '"></img></td></tr>';
  }
  document.getElementById('tbodyContainer').innerHTML = str;
}
  //Week部分
function showInfoWeek(data, tabletop) {
  // console.log(data);
  $('.card-data .btn').on('click',function(){
    $(".dynamic-table tr:nth-child(2), .dynamic-table tr:nth-child(3), .dynamic-table tr:nth-child(4), .dynamic-table tr:nth-child(5), .dynamic-table tr:nth-child(6)").remove();
    var weekNumber = $(this).data('number');
    var weekSheet = "week"+weekNumber;
    // console.log(weekNumber);
    $.each(tabletop.sheets(weekSheet).all(), function(i,weekSheet) {
      var tablePushChi = $('<tr><td>' + weekSheet.chi+ '</td></tr>');
      tablePushChi.appendTo("#table-chi");
      var tablePushEng = $('<tr><td>' + weekSheet.eng+ '</td></tr>');
      tablePushEng.appendTo("#table-eng");
      var tablePushMath = $('<tr><td>' + weekSheet.math+ '</td></tr>');
      tablePushMath.appendTo("#table-math");
      var tablePushSoc = $('<tr><td>' + weekSheet.soc+ '</td></tr>');
      tablePushSoc.appendTo("#table-soc");
      var tablePushBio = $('<tr><td>' + weekSheet.bio+ '</td></tr>');
      tablePushBio.appendTo("#table-bio");
      // $('#dynamicTable .table-content').innerHTML = tablePush;
    })
  })
}
window.addEventListener('DOMContentLoaded', init)

//----- scroll to position + RWD
$(window).on('load',function(){
  if ($(window).width() <  767 ){
    $(document).on('click', '#contect', function(event){
      $('html, body').animate({
          scrollTop: $( $.attr(this, 'href') ).delay(300).offset().top-40
      }, 1000);
    })
  }
  else if($(window).width() >=  767 ){
    $(document).on('click', '#contect', function(event){
      $('html, body').animate({
          scrollTop: $( $.attr(this, 'href') ).delay(500).offset().top-100
      }, 1000);
    })
  }
})
